import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { MatAutocomplete } from "@angular/material/autocomplete";

@Component({
  selector: "lhpe-input",
  templateUrl: "./input.component.html",
  styleUrls: ["./input.component.scss"],
})
export class InputComponent implements OnInit {
  @Input() formGroup?: FormGroup;
  @Input() placeholder?: string;
  @Input() controlName!: string | number | null;
  @Input() control?: FormControl;
  @Input() type!: string;
  @Input() required?: boolean;
  @Input() mask?: string;
  @Input() matAutocomplete?: MatAutocomplete;
  @Input() maxlength?: number;
  @Input() hint?: string;

  //Use on a disabled field to not have it look disabled
  @Input() ignoreDisabledStyling?: boolean;

  _formControl!: FormControl;
  hasMask!: boolean;
  constructor() {}

  ngOnInit(): void {
    if (!this.type) {
      this.type = "text";
    }

    this.hasMask = !!this.mask;
  }

  ngOnChanges(changes: SimpleChanges) {
    //Default to formGroups form control if specified, if not look for a form control
    if (changes.formGroup) {
      this._formControl! = this.formGroup!.get(
        this.controlName as string,
      )! as FormControl;
    } else if (changes.control) {
      this._formControl = this.control!;
    }
  }

  getErrorMessage(formControl: AbstractControl | undefined) {
    if (formControl?.errors) {
      const keys = Object.keys(formControl.errors);

      if (keys.length) {
        if (keys[0] === "required") {
          return "This field is required";
        } else if (typeof formControl.errors[keys[0]] === "string") {
          return formControl.errors[keys[0]];
        }
      }
    }
    return "";
  }
}
